import * as React from "react";
import {
  BarChart3,
  Database,
  LayoutDashboard,
  Megaphone,
  Wrench,
  Users,
} from "lucide-react";

import { NavMain } from "@/components/sidebar/nav-main";
import { NavUser } from "@/components/sidebar/nav-user";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
} from "@/components/ui/sidebar";
import { SidebarMenu } from "../ui/sidebar";
import Logo from "@/assets/logo.svg";

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  // Exemple d'autres données statiques
  const data = {
    navMain: [
      {
        title: "Dashboard",
        url: "/dashboard",
        icon: LayoutDashboard,
      },
      {
        title: "Comptes",
        icon: Users,
        items: [
          { title: "Utilisateurs", url: "/users" },
          { title: "Organisations", url: "/organizations" },
          { title: "Codes promo", url: "/promo-codes" },
          { title: "Abonnements", url: "/subscriptions" },
          { title: "Support", url: "/support" },
        ],
      },
      {
        title: "Recrutement",
        icon: Megaphone,
        items: [
          { title: "Campagnes", url: "/campaigns" },
          { title: "Rendez-vous", url: "/meets" },
          { title: "Messages", url: "/messages" },
          { title: "Templates workflow", url: "/workflow-templates" },
          { title: "Bibliothèque de messages", url: "/message-templates" },
        ],
      },
      {
        title: "Données",
        icon: Database,
        items: [
          { title: "Candidats", url: "/candidates" },
          { title: "Schools", url: "/schools" },
          { title: "Companies", url: "/companies" },
          { title: "Classification entreprises", url: "/company-classification" },
          { title: "Competences", url: "/skills" },
          { title: "Langues", url: "/languages" },
          { title: "Certifications", url: "/certifications" },
          { title: "Centres d'intérêt", url: "/interests" },
          { title: "Cache géocodage", url: "/geo-resolution" },
        ],
      },
      {
        title: "Monitoring",
        icon: BarChart3,
        items: [
          { title: "Tâches worker", url: "/worker-tasks" },
          { title: "Jobs cron", url: "/cron-jobs" },
          { title: "Plugins", url: "/plugins" },
          { title: "Logs plugins", url: "/plugin-logs" },
          { title: "Scraping Stats", url: "/scraping-stats" },
          { title: "Coûts LLM", url: "/llm-costs" },
          { title: "Versions stores", url: "/plugin-store-versions" },
        ],
      },
      {
        title: "Système",
        icon: Wrench,
        items: [
          { title: "Operations", url: "/admin-ops" },
          { title: "Parametres generaux", url: "/settings" },
          { title: "Transfert donnees", url: "/data-transfer" },
          { title: "Feature flags", url: "/feature-flags" },
          { title: "Quotas", url: "/quotas" },
          { title: "Navigateurs serveur", url: "/browser-farm" },
          { title: "Verifications de backup", url: "/backup-verify" },
          { title: "Securite", url: "/security" },
          { title: "Diagnostic e-mail", url: "/mail-diagnostic" },
          { title: "Test classification", url: "/test-classification" },
          { title: "Outils entretien IA", url: "/interview-tools" },
          { title: "Classifications", url: "/classifications" },
        ],
      },
    ],
  };

  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader>
        <SidebarMenu>
          <a href="/">
            <div className="flex flex-row items-center justify-center gap-2 m-2">
              <div className="flex aspect-square size-8 items-center justify-center rounded-lg bg-sidebar-primary text-sidebar-primary-foreground p-2">
                <img src={Logo} alt="Admin" className="w-4 h-4" />
              </div>
              <div className="grid flex-1 text-left text-sm leading-tight">
                <span className="truncate font-semibold">Admin</span>
              </div>
            </div>
          </a>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={data.navMain} />
      </SidebarContent>
      <SidebarFooter>
        <NavUser />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}
